export default "__VITE_ASSET__Ch6f$jdf__"